<!-- Heading -->
<eds-title
  [title]="relatedStrategies.title"
  size="h2"
  theme="primary"
  edsSpacing="xs"
></eds-title>

<!-- Summary -->
<div class="ck-editor" *ngIf="relatedStrategies.summary">
  <div [innerHTML]="relatedStrategies.summary"></div>
</div>

<!-- Tabs -->
<eds-tabs
  *ngIf="relatedStrategies.tabs"
  edsCol
  [followFocus]="true"
  [isNavigation]="false"
  [cacheActive]="true"
>
  <ng-container *ngFor="let tab of relatedStrategies.tabs; let i = index">
    <eds-tab [heading]="tab.displayName">
      <ng-container brComponent="tab-area-{{ i + 1 }}">
        <!-- if content is not authored/unavailable -->
        <div *ngIf="!tab.introParagraph?.value && tab.contentLinks.length <= 0">
          {{ strategyTabContentUnavailable }}
        </div>
        <!-- end -->
        <div [innerHTML]="tab.introParagraph?.value"></div>
        <ul edsList class="list--blocked list--unordered">
          <ng-container *ngFor="let link of tab.contentLinks; let i = index">
            <li edsListItem *ngIf="link.isAllowed">
              <a
                edsLink
                [class.external-link]="link.external"
                [attr.data-signin-required]="link.signInLink"
                [attr.data-signin-custom-intro]="link.signInCustomIntro"
                [attr.data-signin-custom-content-text]="
                  link.signInCustomContentText
                "
                [target]="link.target"
                [href]="link.url"
              >
                {{ link.displayText }}
                <eds-icon
                  *ngIf="
                    link.signInLink && !link.hideLockIcon
                      | ftIsSignInRequired
                      | async
                  "
                  edsPadding
                  edsPaddingLeft="xs"
                  edsTooltip
                  tooltipType="medium"
                  [tooltipContent]="'common.locked-link-tooltip' | translate"
                  tooltipPositionDefault="top"
                  tooltipBehavior="fixed"
                  size="small"
                  type="lock"
                ></eds-icon>
              </a>
            </li>
          </ng-container>
        </ul>
      </ng-container>
    </eds-tab>
  </ng-container>
</eds-tabs>
